module.exports = __webpack_public_path__ + "img/nav-xialou.ba3b6e4f.png";